module.exports = __webpack_public_path__ + "static/media/schermo_intero.82389daa.svg";